var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.swiperize ? _vm.swiper : 'div',{tag:"component",on:{"scrolled":_vm.scrolled}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }